// Mock server data - separated from component for cleaner organization
export const SERVERS_MOCK_DATA = [
  {
    id: "srv-009",
    name: "Payment Processor",
    type: "worker",
    region: "Singapore",
    ip: "",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-12-02T16:00:00Z",
  },
  {
    id: "srv-003",
    name: "Database Primary",
    type: "database",
    region: "Singapore",
    ip: "103.32.67.89",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-11-15T04:00:00Z",
  },
  {
    id: "srv-004",
    name: "Database Replica",
    type: "database",
    region: "Bangkok",
    ip: "",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-11-15T04:30:00Z",
  },
  {
    id: "srv-005",
    name: "Webhook Handler",
    type: "worker",
    region: "Singapore",
    ip: "",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-12-02T16:00:00Z",
  },
  {
    id: "srv-006",
    name: "Queue Processor",
    type: "worker",
    region: "Singapore",
    ip: "",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-11-30T08:00:00Z",
  },
  {
    id: "srv-007",
    name: "Load Balancer",
    type: "gateway",
    region: "Singapore",
    ip: "",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-10-15T00:00:00Z",
  },
  {
    id: "srv-008",
    name: "Redis Cache",
    type: "cache",
    region: "Singapore",
    ip: "",
    status: "healthy",
    isDataReal: false,
    uptime: 0,
    cpu: 0,
    memory: 0,
    disk: 0,
    network: { in: 0, out: 0 },
    requests: 0,
    latency: 0,
    lastRestart: "2024-11-01T00:00:00Z",
  },
];
